<div class="container-fluid">
  <div class="row justify-content-center bg-fondo py-1">
    <div class="col-sm-6 col-md-4 col-lg-4 text-center">
      <img style="height: 75px;" src="../../../assets/img/logo.png" alt="ChevyPlan">
    </div>
  </div>
  <div class="row justify-content-center" *ngIf="imagen">
    <div class="col-lg-12 p-0 banner" [ngClass]="imagen"> 
    </div>
  </div>
</div>